var _defs, _g, _defs2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHasNotStoreProducts = function SvgHasNotStoreProducts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 537,
    viewBox: "0 0 537 537",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e63f7;}.cls-2{stroke:#2e63f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2107 370.236H110.585V470.676H56.9105C55.9734 470.676 55.2107 469.913 55.2107 468.976V370.236Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3011 370.236H73.5053V382.751L82.8978 379.048L92.3011 382.751V370.236Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.585 355.074H152.001C152.938 355.074 153.701 355.836 153.701 356.773V368.537C153.701 369.473 152.938 370.236 152.001 370.236H110.585V355.074Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6199 355.074H110.585V370.236H53.6199C52.6828 370.236 51.9201 369.473 51.9201 368.537V356.773C51.9201 355.836 52.6828 355.074 53.6199 355.074Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8252 355.074H70.0294V370.236H88.8252V355.074Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.721 470.686H110.585L110.585 370.247H150.421V468.987C150.421 469.924 149.658 470.686 148.721 470.686Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.211 458.171H118.136V464.434H131.211V458.171Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3842 436.985H74.7583V470.686H21.084C20.1469 470.686 19.3842 469.924 19.3842 468.987V436.985Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4638 436.985H37.6788V449.501L47.0713 445.797L56.4638 449.501V436.985Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7584 421.823H116.175C117.112 421.823 117.874 422.585 117.874 423.522V435.286C117.874 436.223 117.112 436.985 116.175 436.985H74.7584V421.823Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7934 421.823H74.7584V436.985H17.7934C16.8563 436.985 16.0936 436.223 16.0936 435.286V423.522C16.0936 422.585 16.8563 421.823 17.7934 421.823Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9988 421.823H34.203V436.985H52.9988V421.823Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.895 470.686H74.7584V436.985H114.595V468.987C114.595 469.924 113.832 470.686 112.895 470.686Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3847 458.171H82.3094V464.434H95.3847V458.171Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7648 412.521H146.139V470.686H92.4646C91.5275 470.686 90.7648 469.924 90.7648 468.987V412.521Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.855 412.521H109.059V425.036L118.452 421.333L127.855 425.036V412.521Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.139 397.347H187.555C188.492 397.347 189.255 398.11 189.255 399.047V410.81C189.255 411.747 188.492 412.51 187.555 412.51H146.139V397.347Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1739 397.347H146.139V412.51H89.1739C88.2368 412.51 87.4741 411.747 87.4741 410.81V399.047C87.4741 398.11 88.2368 397.347 89.1739 397.347Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.379 397.347H105.583V412.51H124.379V397.347Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.275 470.686H146.139V412.521H185.975V468.987C185.975 469.924 185.212 470.686 184.275 470.686Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.765 458.171H153.69V464.434H166.765V458.171Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.139 205.204H186.269C182.659 205.204 179.732 208.13 179.732 211.739V507.318C179.732 510.927 182.659 513.853 186.269 513.853H360.139C363.75 513.853 366.677 510.927 366.677 507.318V211.739C366.677 208.13 363.75 205.204 360.139 205.204Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.571 214.985H191.837C190.333 214.985 189.113 216.204 189.113 217.708V501.371C189.113 502.875 190.333 504.094 191.837 504.094H354.571C356.075 504.094 357.295 502.875 357.295 501.371V217.708C357.295 216.204 356.075 214.985 354.571 214.985Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.718 283.085H202.276C199.869 283.085 197.917 285.036 197.917 287.442V368.493C197.917 370.899 199.869 372.85 202.276 372.85H258.718C261.125 372.85 263.076 370.899 263.076 368.493V287.442C263.076 285.036 261.125 283.085 258.718 283.085Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.109 289.414H206.907C205.703 289.414 204.727 290.389 204.727 291.592V338.778C204.727 339.982 205.703 340.957 206.907 340.957H254.109C255.312 340.957 256.288 339.982 256.288 338.778V291.592C256.288 290.389 255.312 289.414 254.109 289.414Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.708 364.136H215.297C210.482 364.136 206.58 368.037 206.58 372.85C206.58 377.663 210.482 381.564 215.297 381.564H245.708C250.522 381.564 254.425 377.663 254.425 372.85C254.425 368.037 250.522 364.136 245.708 364.136Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.727 349.507H230.508",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.222 283.085H288.78C286.373 283.085 284.422 285.036 284.422 287.442V368.493C284.422 370.899 286.373 372.85 288.78 372.85H345.222C347.629 372.85 349.581 370.899 349.581 368.493V287.442C349.581 285.036 347.629 283.085 345.222 283.085Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.602 289.414H293.4C292.197 289.414 291.221 290.389 291.221 291.592V338.778C291.221 339.982 292.197 340.957 293.4 340.957H340.602C341.806 340.957 342.781 339.982 342.781 338.778V291.592C342.781 290.389 341.806 289.414 340.602 289.414Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.201 364.136H301.79C296.976 364.136 293.073 368.037 293.073 372.85C293.073 377.663 296.976 381.564 301.79 381.564H332.201C337.015 381.564 340.918 377.663 340.918 372.85C340.918 368.037 337.015 364.136 332.201 364.136Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.221 349.507H317.001",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.718 397.086H202.276C199.869 397.086 197.917 399.037 197.917 401.443V482.494C197.917 484.9 199.869 486.851 202.276 486.851H258.718C261.125 486.851 263.076 484.9 263.076 482.494V401.443C263.076 399.037 261.125 397.086 258.718 397.086Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.109 403.414H206.907C205.703 403.414 204.727 404.39 204.727 405.593V452.779C204.727 453.982 205.703 454.958 206.907 454.958H254.109C255.312 454.958 256.288 453.982 256.288 452.779V405.593C256.288 404.39 255.312 403.414 254.109 403.414Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.708 478.137H215.297C210.482 478.137 206.58 482.038 206.58 486.851C206.58 491.664 210.482 495.565 215.297 495.565H245.708C250.522 495.565 254.425 491.664 254.425 486.851C254.425 482.038 250.522 478.137 245.708 478.137Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.727 463.508H230.508",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.222 397.086H288.78C286.373 397.086 284.422 399.037 284.422 401.443V482.494C284.422 484.9 286.373 486.851 288.78 486.851H345.222C347.629 486.851 349.581 484.9 349.581 482.494V401.443C349.581 399.037 347.629 397.086 345.222 397.086Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.602 403.414H293.4C292.197 403.414 291.221 404.39 291.221 405.593V452.779C291.221 453.982 292.197 454.958 293.4 454.958H340.602C341.806 454.958 342.781 453.982 342.781 452.779V405.593C342.781 404.39 341.806 403.414 340.602 403.414Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.201 478.137H301.79C296.976 478.137 293.073 482.038 293.073 486.851C293.073 491.664 296.976 495.565 301.79 495.565H332.201C337.015 495.565 340.918 491.664 340.918 486.851C340.918 482.038 337.015 478.137 332.201 478.137Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.221 463.508H317.001",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.79 296.744C224.646 296.744 216.397 288.499 216.397 278.358V267.781C216.397 267.03 217.007 266.42 217.759 266.42H251.82C252.572 266.42 253.182 267.03 253.182 267.781V278.358C253.182 288.499 244.934 296.744 234.79 296.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.82 267.236C252.126 267.236 252.365 267.476 252.365 267.781V278.358C252.365 288.041 244.487 295.927 234.79 295.927C225.092 295.927 217.214 288.052 217.214 278.358V267.781C217.214 267.476 217.454 267.236 217.759 267.236H251.82ZM251.82 265.603H217.759C216.561 265.603 215.58 266.583 215.58 267.781V278.358C215.58 288.967 224.177 297.561 234.79 297.561C245.403 297.561 254 288.967 254 278.358V267.781C254 266.583 253.019 265.603 251.82 265.603Z",
    fill: "#2E63FB",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21 296.744C263.065 296.744 254.817 288.499 254.817 278.358V267.781C254.817 267.03 255.427 266.42 256.179 266.42H290.24C290.992 266.42 291.602 267.03 291.602 267.781V278.358C291.602 288.499 283.354 296.744 273.21 296.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.24 267.236C290.545 267.236 290.785 267.476 290.785 267.781V278.358C290.785 288.041 282.907 295.927 273.21 295.927C263.512 295.927 255.634 288.052 255.634 278.358V267.781C255.634 267.476 255.874 267.236 256.179 267.236H290.24ZM290.24 265.603H256.179C254.98 265.603 254 266.583 254 267.781V278.358C254 288.967 262.597 297.561 273.21 297.561C283.822 297.561 292.419 288.967 292.419 278.358V267.781C292.419 266.583 291.439 265.603 290.24 265.603Z",
    fill: "#4B4E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.618 296.744C301.474 296.744 293.226 288.499 293.226 278.358V267.781C293.226 267.03 293.836 266.42 294.588 266.42H328.638C329.39 266.42 330 267.03 330 267.781V278.358C330 288.499 321.752 296.744 311.608 296.744H311.618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.649 267.236C328.954 267.236 329.194 267.476 329.194 267.781V278.358C329.194 288.041 321.316 295.927 311.618 295.927C301.921 295.927 294.043 288.052 294.043 278.358V267.781C294.043 267.476 294.283 267.236 294.588 267.236H328.638M328.638 265.603H294.588C293.389 265.603 292.409 266.583 292.409 267.781V278.358C292.409 288.967 301.006 297.561 311.618 297.561C322.231 297.561 330.828 288.967 330.828 278.358V267.781C330.828 266.583 329.848 265.603 328.649 265.603H328.638Z",
    fill: "#2E63FB",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.06 296.744C339.916 296.744 331.667 288.499 331.667 278.358V267.781C331.667 267.03 332.278 266.42 333.029 266.42H367.091C367.842 266.42 368.453 267.03 368.453 267.781V278.358C368.453 288.499 360.204 296.744 350.06 296.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.091 267.236C367.396 267.236 367.635 267.476 367.635 267.781V278.358C367.635 288.041 359.758 295.927 350.06 295.927C340.362 295.927 332.485 288.052 332.485 278.358V267.781C332.485 267.476 332.724 267.236 333.029 267.236H367.091ZM367.091 265.603H333.029C331.831 265.603 330.85 266.583 330.85 267.781V278.358C330.85 288.967 339.447 297.561 350.06 297.561C360.673 297.561 369.27 288.967 369.27 278.358V267.781C369.27 266.583 368.289 265.603 367.091 265.603Z",
    fill: "#4B4E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.348 296.744C186.204 296.744 177.956 288.499 177.956 278.358V267.781C177.956 267.03 178.566 266.42 179.318 266.42H213.368C214.12 266.42 214.73 267.03 214.73 267.781V278.358C214.73 288.499 206.482 296.744 196.337 296.744H196.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.379 267.236C213.684 267.236 213.924 267.476 213.924 267.781V278.358C213.924 288.041 206.046 295.927 196.348 295.927C186.651 295.927 178.773 288.052 178.773 278.358V267.781C178.773 267.476 179.013 267.236 179.318 267.236H213.379ZM213.379 265.603H179.318C178.119 265.603 177.138 266.583 177.138 267.781V278.358C177.138 288.967 185.735 297.561 196.348 297.561C206.961 297.561 215.558 288.967 215.558 278.358V267.781C215.558 266.583 214.577 265.603 213.379 265.603Z",
    fill: "#4B4E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.261 266.964L192.949 220.671C193.199 219.865 193.94 219.331 194.779 219.331H223.959L214.904 266.964H178.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.978 220.159L214.229 266.158H179.372L193.733 220.932C193.875 220.475 194.3 220.159 194.779 220.159H222.978ZM224.951 218.525H194.779C193.592 218.525 192.535 219.299 192.175 220.431L177.138 267.781H215.58L224.951 218.514V218.525Z",
    fill: "#4B4E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.871 266.964L257.911 219.342H288.53L291.548 266.964H254.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.756 220.159L290.676 266.158H255.743L258.674 220.159H287.756ZM289.292 218.525H257.149L254 267.792H292.419L289.292 218.525Z",
    fill: "#4B4E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.571 266.964L225.637 219.342H256.277L253.237 266.964H216.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.405 220.159L252.474 266.158H217.563L226.313 220.159H255.405ZM257.149 218.525H224.962L215.591 267.792H254.011L257.16 218.525H257.149Z",
    fill: "#2E63FB",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.537 266.964L322.46 219.331H351.651C352.49 219.331 353.231 219.865 353.481 220.671L368.169 266.964H331.547H331.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.64 220.159C352.119 220.159 352.544 220.464 352.686 220.932L367.036 266.158H332.212L323.441 220.159H351.64ZM351.64 218.525H321.469L330.861 267.792H369.281L354.255 220.442C353.895 219.31 352.839 218.536 351.651 218.536L351.64 218.525Z",
    fill: "#4B4E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.182 266.964L290.164 219.342H320.793L329.869 266.964H293.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.117 220.159L328.889 266.158H293.956L291.036 220.159H320.117ZM321.469 218.525H289.292L292.419 267.792H330.861L321.469 218.525Z",
    fill: "#2E63FB",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.018 153.04L211.505 159.412L217.879 162.897L211.505 166.383L208.018 172.755L204.531 166.383L198.157 162.897L204.531 159.412L208.018 153.04Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.633 2.26562L361.12 8.63773L367.494 12.1233L361.12 15.6089L357.633 21.981L354.146 15.6089L347.772 12.1233L354.146 8.63773L357.633 2.26562Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.815 122.922L382.302 129.294L388.676 132.78L382.302 136.265L378.815 142.637L375.328 136.265L368.954 132.78L375.328 129.294L378.815 122.922Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.855 287.703L131.331 294.076L137.705 297.561L131.331 301.047L127.855 307.419L124.368 301.047L117.994 297.561L124.368 294.076L127.855 287.703Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1612 333.201L10.4385 337.373L14.6117 339.65L10.4385 341.937L8.1612 346.098L5.87302 341.937L1.6998 339.65L5.87302 337.373L8.1612 333.201Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.43 316.667L530.707 320.838L534.88 323.115L530.707 325.402L528.43 329.574L526.152 325.402L521.979 323.115L526.152 320.838L528.43 316.667Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.059 69.2762L111.598 73.9273L116.24 76.4653L111.598 79.0032L109.059 83.6543L106.51 79.0032L101.868 76.4653L106.51 73.9273L109.059 69.2762Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.504 339.65L410.991 346.022L417.365 349.507L410.991 352.993L407.504 359.365L404.029 352.993L397.654 349.507L404.029 346.022L407.504 339.65Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.764 174.574L400.051 217.883C398.363 219.593 398.384 222.359 400.095 224.048L424.361 247.968C425.243 248.839 425.723 250.048 425.657 251.29L424.786 268.206L441.696 267.095C442.939 267.008 444.159 267.465 445.042 268.337L469.307 292.257C471.018 293.945 473.786 293.923 475.474 292.213L518.187 248.904C519.876 247.194 519.854 244.428 518.144 242.739L448.931 174.53C447.221 172.842 444.453 172.864 442.764 174.574Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.964 217.044C439.964 217.044 457.147 212.632 468.534 223.852C479.92 235.071 475.747 252.303 475.747 252.303C475.747 252.303 458.564 256.714 447.177 245.495C435.791 234.276 439.964 217.044 439.964 217.044Z",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.846 238.742C456.09 240.953 459.697 240.931 461.909 238.687C464.121 236.443 464.099 232.838 461.854 230.627C459.61 228.416 456.003 228.437 453.791 230.681C451.579 232.925 451.601 236.531 453.846 238.742Z",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.278 77.1298L315.062 135.459C314.375 137.768 311.956 139.086 309.646 138.4L276.958 128.76C275.759 128.412 274.474 128.586 273.417 129.239L259.034 138.193L251.82 122.867C251.287 121.745 250.306 120.896 249.107 120.547L216.419 110.907C214.109 110.221 212.791 107.803 213.477 105.494L230.693 47.1645C231.379 44.8553 233.798 43.5373 236.108 44.2235L329.325 71.7162C331.635 72.4024 332.953 74.8206 332.267 77.1298H332.278Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.769 76.8683C260.712 77.4456 259.775 78.219 259.023 79.1558C258.271 80.0925 257.704 81.1709 257.356 82.3255C257.007 83.4801 256.909 84.6891 257.029 85.8873C257.16 87.0855 257.519 88.251 258.097 89.3076L259.295 91.5079L268.067 107.618L284.182 98.8494L286.383 97.6512C288.519 96.4857 290.109 94.5251 290.796 92.1941C291.482 89.8631 291.221 87.3469 290.055 85.212C288.889 83.0771 286.928 81.4868 284.596 80.8005C282.264 80.1143 279.747 80.3757 277.612 81.5412L275.411 82.7394L274.212 80.5391C273.635 79.4825 272.861 78.5458 271.924 77.7942C270.987 77.0317 269.908 76.4762 268.753 76.1276C267.598 75.7791 266.389 75.6811 265.19 75.8009C263.991 75.9316 262.826 76.291 261.769 76.8683V76.8683Z",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34 158.911L144.08 200.117C145.845 201.751 145.965 204.507 144.33 206.271L121.241 231.324C120.402 232.239 119.988 233.47 120.108 234.711L121.797 251.573L104.853 251.268C103.611 251.246 102.413 251.758 101.574 252.673L78.4848 277.726C76.8504 279.491 74.0937 279.61 72.3285 277.976L27.589 236.77C25.8238 235.136 25.704 232.38 27.3384 230.616L93.2055 159.172C94.8399 157.407 97.5966 157.288 99.3618 158.921L99.34 158.911Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8086 209.049C101.53 209.049 102.925 207.654 102.925 205.933C102.925 204.213 101.53 202.818 99.8086 202.818C98.0875 202.818 96.6923 204.213 96.6923 205.933C96.6923 207.654 98.0875 209.049 99.8086 209.049Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1581 222.773C88.8792 222.773 90.2744 221.379 90.2744 219.658C90.2744 217.938 88.8792 216.543 87.1581 216.543C85.4371 216.543 84.0418 217.938 84.0418 219.658C84.0418 221.379 85.4371 222.773 87.1581 222.773Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4968 236.509C76.2179 236.509 77.6131 235.114 77.6131 233.393C77.6131 231.673 76.2179 230.278 74.4968 230.278C72.7758 230.278 71.3806 231.673 71.3806 233.393C71.3806 235.114 72.7758 236.509 74.4968 236.509Z",
    fill: "white",
    stroke: "#2E63FB",
    className: "cls-2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.707 402.36L480.36 370.159C478.383 368.786 475.667 369.274 474.294 371.25L428.021 437.805C426.647 439.781 427.136 442.496 429.113 443.869L475.46 476.071C477.437 477.444 480.153 476.956 481.526 474.98L527.799 408.425C529.172 406.449 528.684 403.734 526.707 402.36Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.304 404.919L480.544 377.989C479.556 377.303 478.198 377.547 477.511 378.535L450.572 417.282C449.885 418.27 450.13 419.628 451.118 420.314L489.878 447.244C490.866 447.931 492.224 447.686 492.911 446.698L519.85 407.951C520.537 406.963 520.292 405.606 519.304 404.919Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.744 461.487L444.772 444.137C440.819 441.391 435.387 442.368 432.639 446.319C429.891 450.271 430.869 455.702 434.822 458.448L459.794 475.798C463.747 478.545 469.179 477.568 471.927 473.616C474.674 469.664 473.697 464.234 469.744 461.487Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.442 426.093L465.603 440.797",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.879 392.392L359.644 424.755C357.672 426.135 357.193 428.852 358.574 430.823L405.078 497.216C406.459 499.187 409.177 499.666 411.148 498.286L457.383 465.923C459.355 464.543 459.834 461.826 458.453 459.855L411.949 393.462C410.568 391.49 407.85 391.011 405.879 392.392Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.72 400.227L367.054 427.292C366.068 427.982 365.829 429.341 366.519 430.326L393.593 468.979C394.283 469.965 395.642 470.204 396.628 469.514L435.294 442.449C436.279 441.759 436.519 440.401 435.829 439.415L408.755 400.762C408.064 399.777 406.706 399.537 405.72 400.227Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.721 466.255L416.809 483.692C412.866 486.452 411.907 491.886 414.669 495.828C417.43 499.77 422.865 500.729 426.809 497.968L451.72 480.531C455.664 477.771 456.622 472.337 453.861 468.395C451.1 464.452 445.664 463.494 441.721 466.255Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.244 482.744L417.551 472.723",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.757 477.767L420.874 462.985",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.766 479.008H371.297L380.809 535.638H505.264L514.766 479.008Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.022 493.092L400.967 521.554",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.1 493.092L422.465 521.554",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.037 493.092V521.554",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.049 493.092L464.469 521.554",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.04 493.092L485.88 521.554",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.566 459.293H359.496C357.787 459.293 356.402 460.678 356.402 462.386V475.915C356.402 477.623 357.787 479.008 359.496 479.008H526.566C528.275 479.008 529.661 477.623 529.661 475.915V462.386C529.661 460.678 528.275 459.293 526.566 459.293Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.684 511.305L463.881 475.871C460.579 473.508 459.795 468.922 462.127 465.589C464.491 462.201 469.176 461.406 472.532 463.813L525.335 499.247C528.637 501.61 529.421 506.196 527.089 509.529C524.725 512.917 520.04 513.712 516.684 511.305Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.379 511.305L422.181 475.871C425.483 473.508 426.268 468.922 423.936 465.589C421.571 462.201 416.886 461.406 413.53 463.813L360.727 499.247C357.426 501.61 356.641 506.196 358.973 509.529C361.337 512.917 366.023 513.712 369.379 511.305Z",
    fill: "white",
    stroke: "#4B4E5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 536.591,
    height: 536.455,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHasNotStoreProducts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hasNotStoreProducts.0392bc63.svg";
export { ForwardRef as ReactComponent };